import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect, postWithRedirect } from 'utils/axios'
import { KPI_UNIT } from 'types/Enums'
import { TPutMetricCalculationBlock } from 'types/GlobalMetric'
import {
  IMetric,
  IMetricConfig,
  THeadlineMetric,
  TMetricCondition,
  TMetricFilterType
} from 'types/GlobalMetric'
import { GlobalFilterVariant } from 'types/GlobalGlobalFilter'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/kpis`

export async function getAll() {
  return getWithRedirect<IMetric[]>(URL)
}

export async function getHeadline() {
  return getWithRedirect<THeadlineMetric>(`${URL}/headline`)
}

export async function getAllFilterOptions() {
  return postWithRedirect(`${URL}/filter-options`, {
    data: { global_filter: { variant: GlobalFilterVariant.ALL } }
  })
}

export type TPatchKpiTemplateCalculationBody = {
  name?: string
  unit?: string
  blocks: TPutMetricCalculationBlock
}

export type TPatchKpiTemplateSettingsBody = {
  active?: boolean
  private?: boolean
  permissions?: { account_id?: string; group_id?: string }[]
  filters?:
    | {
        attribute_option_id: string
        type: TMetricFilterType
        condition: TMetricCondition
        right_value: string | null
      }[]
    | null
}

export async function updateCalculation(
  id: string,
  body: { data: TPatchKpiTemplateCalculationBody }
) {
  return axios.patch<{ data: IMetric }>(
    `${URL}/${id}/calculation`,
    body,
    parseAuthenticationHeader()
  )
}

export async function updateSettings(
  id: string,
  body: { data: TPatchKpiTemplateSettingsBody }
) {
  return axios.patch<{ data: IMetric }>(
    `${URL}/${id}/settings`,
    body,
    parseAuthenticationHeader()
  )
}

export async function create(body: {
  data: { name: string; unit: KPI_UNIT; blocks: TPutMetricCalculationBlock }
}) {
  return axios.post(URL, body, parseAuthenticationHeader())
}

export async function removeCalculation(id: string) {
  return axios.delete<{ data: IMetric }>(
    `${URL}/${id}/calculation`,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export interface PutConfigValueBody {
  attribute_value: string
  value: number | null
}

export async function putTargetValues(id: string, body: PutConfigValueBody) {
  return axios.put<{ data: IMetricConfig }>(
    `${URL}/${id}/config`,
    { data: body },
    parseAuthenticationHeader()
  )
}

